import { useTranslation } from "react-i18next";

type Tone = "pos" | "neg" | "flag" | "info" | "muted";

const MAP: Record<string, { tone: Tone; fallback: string }> = {
  flagged: { tone: "neg", fallback: "Flagget" },
  pending: { tone: "flag", fallback: "Til gjennomgang" },
  approved: { tone: "pos", fallback: "Godkjent" },
  godkjent: { tone: "pos", fallback: "Klar for betaling" },
  delvis_godkjent: { tone: "info", fallback: "Delvis godkjent" },
  betalt: { tone: "muted", fallback: "Betalt" },
  ukjent_avsender: { tone: "neg", fallback: "Mistenkelig avsender" },
  duplikat: { tone: "flag", fallback: "Duplikat" },
  karantene: { tone: "neg", fallback: "Karantene" },
  svindel: { tone: "neg", fallback: "Svindelforsøk" },
  avvist: { tone: "muted", fallback: "Avvist" },
  analyse_feilet: { tone: "neg", fallback: "Analyse feilet" },
};

const TONE_CLS: Record<Tone, string> = {
  pos: "bg-pos/10 text-pos",
  neg: "bg-neg/10 text-neg",
  flag: "bg-flag/10 text-flag",
  info: "bg-info/10 text-info",
  muted: "bg-black/[0.05] text-muted",
};

const TONE_DOT: Record<Tone, string> = {
  pos: "bg-pos",
  neg: "bg-neg",
  flag: "bg-flag",
  info: "bg-info",
  muted: "bg-faint",
};

export default function StatusBadge({ status, dot = true }: { status: string; dot?: boolean }) {
  const { t } = useTranslation();
  const m = MAP[status] || { tone: "muted" as Tone, fallback: status };
  const label = t(`badge.${status}`, { defaultValue: m.fallback });
  return (
    <span className={`cx-chip ${TONE_CLS[m.tone]}`}>
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${TONE_DOT[m.tone]}`} />}
      {label}
    </span>
  );
}
